import { Component } from '@angular/core';

@Component({
  selector: 'adxad-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss']
})
export class AuthLayoutComponent {}
